import React, { useState } from "react";
import TableOfContents, { Heading } from "../TableOfContents/TableOfContents.tsx";

type Props = {
  headings: Heading[];
};

const TocMobile = ({ headings }: Props) => {
  const [open, setOpen] = useState(false);

  const toggleModal = () => {
    setOpen(!open);
  };

  return (
    <div>
      <button
        className="btn btn-circle fixed bottom-8 right-8 md:hidden z-[8]"
        onClick={toggleModal}
      >
        <img src="https://static.igem.wiki/teams/4888/wiki/tocnew.svg"
        alt="TOC"
        width="20"
        height="auto"
        style={{border:"none", padding:'none'}}
        />
      </button>
      {open && (
        <div className="modal modal-bottom">
          <div className="modal-box relative">
            
            <div className="display-table ml-5 mr-8 mt-5">
              <TableOfContents headings={headings} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TocMobile;
